module.exports = __webpack_public_path__ + "static/media/2.35a39a2e.png";